import React, { useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/bthTriangle.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";

const profileOptions = [
  { value: "CUSTOMER", label: "Customer" },
  { value: "OPERATION", label: "Operation" },
];

const statusOptions = [
  { value: "Approved", label: "Approved" },
  { value: "In-Progress", label: "In-Progress" },
  { value: "Blocked", label: "Blocked" },
  { value: "Pending", label: "Pending" },
  { value: "Rejected", label: "Rejected" },
];

const MWalletFilterModal = ({
  show,
  handleClose,
  setTopUpReqData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
  defaultFilterData,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: filterData,
    mode: "onChange",
  });

  const userRole = sessionStorage.getItem("userRole");
  const [selectedTab, setSelectedTab] = useState(
    userRole === "CUST" ? "Amount" : "User Id"
  );

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");

  const onSubmit = () => {
    fetchCustomerData(currentPage);
  };

  const fetchCustomerData = async (currentPage) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        ...filterData,
        profile: filterData.profile?.value || "",
        status: filterData.status?.length > 0 ? filterData.status : [],
        fromDate: formatDate(filterData.fromDate),
        toDate: formatDate(filterData.toDate),
      };

      const response = await axiosPostApi(
        `${
          apiList.FETCH_MAIN_WALLET_HISTORY
        }?&pageSize=${pageSize}&pageNo=${1}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setTopUpReqData(modifiedData);
        setNoData(modifiedData?.length === 0);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });
        setTopUpReqData([]);
        setNoData(true);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return (
      response &&
      response?.map((customer, index) => ({
        ...customer,
        id: index + 1,
        address:
          customer.address1 +
          ", " +
          customer.address2 +
          ", " +
          customer.address3,
      }))
    );
  };

  const onReset = () => {
    handleReset();
    reset(defaultFilterData);
  };

  // Define tabs based on userRole
  const tabs =
    userRole === "CUST"
      ? ["Amount", "Status", "Created Date"]
      : [
          "User Id",
          "Customer Id",
          "Amount",
          "Profile",
          "Status",
          "Created Date",
        ];

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                }}
              >
                <h5 className="modal-title main-title">Filter</h5>
                <HighlightOffIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {tabs.map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content">
                      {selectedTab === "User Id" && userRole !== "CUST" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <Controller
                              name="userId"
                              control={control}
                              render={({ field }) => (
                                <>
                                  <label className="dateLabel">User ID</label>
                                  <input
                                    {...field}
                                    type="text"
                                    placeholder="Enter User ID"
                                    className="dateInput"
                                    maxLength={20}
                                    value={filterData.userId}
                                    onChange={(e) => {
                                      const val = e.target.value.replace(
                                        /[^a-zA-Z0-9]/g,
                                        ""
                                      );
                                      setFilterData((prev) => ({
                                        ...prev,
                                        userId: val,
                                      }));
                                      field.onChange(val);
                                    }}
                                  />
                                </>
                              )}
                            />
                          </div>
                        </div>
                      )}
                      {selectedTab === "Customer Id" && userRole !== "CUST" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <Controller
                              name="customerId"
                              control={control}
                              render={({ field }) => (
                                <>
                                  <label className="dateLabel">
                                    Customer ID
                                  </label>
                                  <input
                                    {...field}
                                    type="text"
                                    placeholder="Enter Customer ID"
                                    className="dateInput"
                                    maxLength={20}
                                    value={filterData.customerId}
                                    onChange={(e) => {
                                      const val = e.target.value.replace(
                                        /[^a-zA-Z0-9]/g,
                                        ""
                                      );
                                      setFilterData((prev) => ({
                                        ...prev,
                                        customerId: val,
                                      }));
                                      field.onChange(val);
                                    }}
                                  />
                                </>
                              )}
                            />
                          </div>
                        </div>
                      )}
                      {selectedTab === "Amount" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            gap: "16px",
                            flexDirection: "row",
                          }}
                        >
                          <div className="dateField" style={{ flex: 1 }}>
                            <label className="dateLabel">From Amount</label>
                            <div className="dateInputWrapper">
                              <Controller
                                name="fromAmount"
                                control={control}
                                render={({ field }) => (
                                  <>
                                    <input
                                      {...field}
                                      type="text"
                                      placeholder="0.00"
                                      className="dateInput"
                                      value={filterData.fromAmount}
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        if (/^\d*\.?\d*$/.test(val)) {
                                          setFilterData((prev) => ({
                                            ...prev,
                                            fromAmount: val,
                                          }));
                                          field.onChange(val);
                                        }
                                      }}
                                    />
                                  </>
                                )}
                              />
                            </div>
                          </div>
                          <div className="dateField" style={{ flex: 1 }}>
                            <label className="dateLabel">To Amount</label>
                            <div className="dateInputWrapper">
                              <Controller
                                name="toAmount"
                                control={control}
                                render={({ field }) => (
                                  <>
                                    <input
                                      {...field}
                                      type="text"
                                      placeholder="0.00"
                                      className="dateInput"
                                      value={filterData.toAmount}
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        if (/^\d*\.?\d*$/.test(val)) {
                                          setFilterData((prev) => ({
                                            ...prev,
                                            toAmount: val,
                                          }));
                                          field.onChange(val);
                                        }
                                      }}
                                    />
                                  </>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {selectedTab === "Profile" && userRole !== "CUST" && (
                        <div className="dateField">
                          <label className="dateLabel">Profile</label>
                          <div className="dateInputWrapper">
                            <select
                              value={filterData.profile?.value || ""}
                              onChange={(e) => {
                                const selected = profileOptions.find(
                                  (opt) => opt.value === e.target.value
                                );
                                setFilterData((prev) => ({
                                  ...prev,
                                  profile: selected,
                                }));
                              }}
                              className="dateInput"
                            >
                              <option value="" disabled>
                                Select Profile
                              </option>
                              {profileOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                      {selectedTab === "Status" && (
                        <div className="dateField">
                          <label
                            className="dateLabel"
                            style={{
                              marginBottom: "0.5rem",
                              fontWeight: "600",
                              fontSize: "25px",
                            }}
                          >
                            Status
                          </label>
                          <div
                            className="dateInputWrapper"
                            style={{
                              display: "flex",
                              gap: "1rem",
                              flexWrap: "wrap",
                              padding: "0.75rem",
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #ced4da",
                              borderRadius: "0.5rem",
                            }}
                          >
                            {statusOptions.map((status) => (
                              <label
                                key={status.value}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  padding: "0.5rem 0.75rem",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={(filterData.status || []).includes(
                                    status.value
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const newStatus = isChecked
                                      ? [
                                          ...(filterData.status || []),
                                          status.value,
                                        ]
                                      : (filterData.status || []).filter(
                                          (v) => v !== status.value
                                        );
                                    setValue("status", newStatus);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: newStatus,
                                    }));
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                                {status.label}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value) =>
                                  !value ||
                                  !filterData.toDate ||
                                  new Date(value) <=
                                    new Date(filterData.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, formValues) =>
                                  !formValues.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <span className="error-text">
                                      {errors.fromDate.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value) =>
                                  !value ||
                                  !filterData.fromDate ||
                                  new Date(value) >=
                                    new Date(filterData.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, formValues) =>
                                  !formValues.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <span className="error-text">
                                      {errors.toDate.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button type="submit" className="btn btn-submit">
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MWalletFilterModal;
